import React, { useEffect, useState } from 'react';
import axios from "axios";
import {
    Dialog,
    DialogActions,
    DialogContent,
    Box, Typography,
    TextField
} from "@mui/material";
import PropTypes from 'prop-types'
import * as config from "../../../next.config"
import LoadingButton from '@mui/lab/LoadingButton'
import { styled } from "@mui/system"
import { useTranslation } from 'next-i18next'
import FormHelperTxet from '@mui/material/FormHelperText'
import style from '../../../styles/mystyle.module.css'
import Rating from '@mui/material/Rating'
import { useRouter } from 'next/router'
import {getTermsByVocabCode} from '../../../components/helpers/global/term/term'
import { printLogs } from '../../helpers/helpers';
import {Customebtn} from "../StyledComponent/HintDialog1.style"
import {CustomeForm} from "../StyledComponent/HintDialog1.style"
import {CustomeDialogActions} from "../StyledComponent/HintDialog1.style"
import {CustomeRating} from "../StyledComponent/HintDialog1.style"


export default function RatingDialog(props) {
    const { t } = useTranslation("common")
    // const classes = useStyles()

    const [inputList, setInputList] = useState([{
        ratingTypes: { "entity-punctuality-in-appointments": { ratingTypeId: "", degree: 0, id: "", operation: "" }, "entity-cleanliness-of-the-place": { ratingTypeId: 0, degree: 0, id: "", operation: " " }, "entity-service-quality": { ratingTypeId: 0, degree: 0, id: "", operation: " " } },
        errorArray: {
            "entity-punctuality-in-appointments": { value: false, message: t("validateRating") },
            "entity-cleanliness-of-the-place": { value: false, message: t("validateRating") },
            "entity-service-quality": { value: false, message: t("validateRating") },
            waitingTime: { value: false, message: t("validateRatingWaitingTime") },
            comment: { value: false, message: t("validateRatingcomment") },
        },
        waitingTime: null,
        comment: null
    }])
    const [errors, setErrors] = useState([])
    const [number, setNumber] = useState("")
    const [note, setNote] = useState("")

    const [Close, setClose] = useState(true)
    const [value, setValue] = useState(2)
    const [ratingCategories, setRatingCategories] = useState([]);
    const [ratingTypes, setRatingTypes] = useState([]);
    const { router, locale } = useRouter();

    //    printLogs("props.updateRating", props.updateRating)



    const handleChange = (e) => {

        const value = { ...inputList };

        if (e.target.name == "entity-punctuality-in-appointments") {
            printLogs("e.target.name", ratingTypes.filter(i => i.code == "entity-punctuality-in-appointments"))
            value[0].ratingTypes["entity-punctuality-in-appointments"].ratingTypeId = ratingTypes.filter(i => i.code == "entity-punctuality-in-appointments")[0].id
            value[0].ratingTypes["entity-punctuality-in-appointments"].degree = e.target.value


        }
        if (e.target.name == "entity-cleanliness-of-the-place") {
            value[0].ratingTypes["entity-cleanliness-of-the-place"].ratingTypeId = ratingTypes.filter(i => i.code == "entity-cleanliness-of-the-place")[0].id
            value[0].ratingTypes["entity-cleanliness-of-the-place"].degree = e.target.value


        }
        if (e.target.name == "entity-service-quality") {
            value[0].ratingTypes["entity-service-quality"].ratingTypeId = ratingTypes.filter(i => i.code == "entity-service-quality")[0].id
            value[0].ratingTypes["entity-service-quality"].degree = e.target.value


        }
        if (e.target.name == "comment") {
            value[0].comment = e.target.value


        }
        if (e.target.name == "waitingTime") {
            value[0].waitingTime = e.target.value


        }
        setInputList(value);
        handleError(value, e.target.name);
        // if(e.target.name=="entity-service-quality"){
        //     value[0].ratingTypes["entity-cleanliness-of-the-place"]=e.target.value


        // }


    }
    const handleError = (value, name) => {


        let formIsValide = true;
        if (name == "entity-punctuality-in-appointments") {
            if (value[0].ratingTypes["entity-punctuality-in-appointments"].degree == null || value[0].ratingTypes["entity-punctuality-in-appointments"].degree == 0) {
                formIsValide = false;
                value[0].errorArray["entity-punctuality-in-appointments"].value = true;
            } else {
                value[0].errorArray["entity-punctuality-in-appointments"].value = false;
            }
            return formIsValide;
        }
        if (name == "entity-cleanliness-of-the-place") {
            if (value[0].ratingTypes["entity-cleanliness-of-the-place"].degree == null || value[0].ratingTypes["entity-cleanliness-of-the-place"].degree == 0) {
                formIsValide = false;
                value[0].errorArray["entity-cleanliness-of-the-place"].value = true;
            } else {
                value[0].errorArray["entity-cleanliness-of-the-place"].value = false;
            }
            return formIsValide;
        }
        if (name == "entity-service-quality") {
            if (value[0].ratingTypes["entity-service-quality"].degree == null || value[0].ratingTypes["entity-service-quality"].degree == 0) {
                formIsValide = false;
                value[0].errorArray["entity-service-quality"].value = true;
            } else {
                value[0].errorArray["entity-service-quality"].value = false;
            }
            return formIsValide;
        }

        if (name == "comment") {
            if (value[0].comment == null || value[0].comment == false || value[0].comment.length < 10) {
                formIsValide = false;
                value[0].errorArray.comment.value = true;
            } else {
                value[0].errorArray.comment.value = false;
            }

            return formIsValide;
        }

        if (name == "waitingTime") {

            if (value[0].waitingTime == null || value[0].waitingTime == false) {
                formIsValide = false;
                value[0].errorArray.waitingTime.value = true;
            } else {
                value[0].errorArray.waitingTime.value = false;
            }
            return formIsValide;
        }


    };


    const handleSend = (e) => {
        let checkNull = null
        checkNull = handleError(inputList, "entity-punctuality-in-appointments") && handleError(inputList, "entity-cleanliness-of-the-place") && handleError(inputList, "entity-service-quality")
            && handleError(inputList, "waitingTime") && handleError(inputList, "comment")
        if (checkNull) {
            let degreeList = []
            let data = {}
            if (inputList[0].ratingTypes != null) {
                degreeList.push(inputList[0].ratingTypes["entity-punctuality-in-appointments"])
                degreeList.push(inputList[0].ratingTypes["entity-cleanliness-of-the-place"])
                degreeList.push(inputList[0].ratingTypes["entity-service-quality"])
            }
            printLogs("inputList==", degreeList)
            printLogs("props==", ratingCategories)
            if (degreeList.length > 0 && ratingCategories.length > 0 && ratingCategories.filter(i => i.code == "entity").length > 0) {

                data.evaluateId = props.entityDetailsId
                data.waitingTime = inputList[0].waitingTime
                data.comment = inputList[0].comment
                data.active = false
                data.ratingCategoryId = ratingCategories.filter(i => i.code == "entity").length && ratingCategories.filter(i => i.code == "entity")[0].id
                data.ratingDegree = degreeList
                data.note = "this is add rating from web"

                axios({
                    method: "POST",
                    url: `${config["basePath"]}/api/rating/post`,
                    data: data,
                    headers: {
                        "Content-Type": "application/json",
                        "accept-language": locale
                    }
                })
                    .then(resp => {
                        printLogs("resp=======w", resp)
                        if (resp.data.data.id) {
                            props.callback({ open: true, Type: "success", Text: t("ratingSuccessText") })
                            // setConfirmDialog({
                            //     open: false
                            // })
                            // setDialogData({
                            //     open: true,
                            //     Type: "success",
                            //     Text: t("cancelText")
                            // })

                        }
                        else {
                            printLogs("resp=======w5", props)
                            props.callback({ open: true, Type: "error", Text: resp.data.data.subErrors[0].message })


                            // setConfirmDialog({
                            //     open: false
                            // })
                            // setDialogData({
                            //     open: true,
                            //     Type: "error",
                            //     Text: resp.data.data.data.unsuccessful.objects[0].errors
                            // })

                        }
                    })
                    .catch(error => (error));






            }
        }
        else {

            handleError(inputList, "entity-punctuality-in-appointments")
            handleError(inputList, "entity-cleanliness-of-the-place")
            handleError(inputList, "entity-service-quality")
            handleError(inputList, "waitingTime")
            handleError(inputList, "comment")
            setInputList({ ...inputList })
        }
    }


    const handleUpdate = (e) => {
        let checkNull = null
        checkNull = handleError(inputList, "entity-punctuality-in-appointments") && handleError(inputList, "entity-cleanliness-of-the-place") && handleError(inputList, "entity-service-quality")
            && handleError(inputList, "waitingTime") && handleError(inputList, "comment")
        if (checkNull) {
            let degreeList = []
            let data = {}
            if (inputList[0].ratingTypes != null) {
                degreeList.push(inputList[0].ratingTypes["entity-punctuality-in-appointments"])

                degreeList.push(inputList[0].ratingTypes["entity-cleanliness-of-the-place"])
                degreeList.push(inputList[0].ratingTypes["entity-service-quality"])
            }
            printLogs("inputList==", degreeList)
            printLogs("props==", ratingCategories)
            if (degreeList.length > 0 && ratingCategories.length > 0 && ratingCategories.filter(i => i.code == "entity").length > 0) {
                data.id = props.updateRating.id

                data.waitingTime = inputList[0].waitingTime
                data.comment = inputList[0].comment
                data.active = false
                data.ratingDegree = degreeList
                data.note = "this is add rating from web"
                data.operation = "edit"
                axios({
                    method: "POST",
                    url: `${config["basePath"]}/api/rating/patch`,
                    data: data,
                    headers: {
                        "Content-Type": "application/json",
                        "accept-language": locale
                    }
                })
                    .then(resp => {
                        printLogs("resp=======w5544", resp)
                        if (resp.data.data.successful.count > 0) {
                            props.callback({ open: true, Type: "success", Text: t("ratingSuccessText") })
                            // setConfirmDialog({
                            //     open: false
                            // })
                            // setDialogData({
                            //     open: true,
                            //     Type: "success",
                            //     Text: t("cancelText")
                            // })

                        }
                        else {
                            printLogs("resp=======w5", props)
                            props.callback({ open: true, Type: "error", Text: resp.data.data.unsuccessful.objects[0].errors })


                            // setConfirmDialog({
                            //     open: false
                            // })
                            // setDialogData({
                            //     open: true,
                            //     Type: "error",
                            //     Text: resp.data.data.data.unsuccessful.objects[0].errors
                            // })

                        }
                    })
                    .catch(error =>(error));






            }
        }
        else {

            handleError(inputList, "entity-punctuality-in-appointments")
            handleError(inputList, "entity-cleanliness-of-the-place")
            handleError(inputList, "entity-service-quality")
            handleError(inputList, "waitingTime")
            handleError(inputList, "comment")
            setInputList({ ...inputList })
        }
    }
    useEffect(() => {

        getTermsByVocabCode("rating-types", locale)
            .then(res => setRatingTypes(JSON.parse(res).filter(x => x.field1 == "entity" && x.language.code == locale)))

            .catch(err => (err));
        getTermsByVocabCode("rating-categories", locale)
            .then(res => {
                setRatingCategories(JSON.parse(res));
            })


        if (props.updateRating != null && props.updateRating.evaluateId == props.entityDetailsId) {
            let values = props.updateRating
            const value = { ...inputList };

            if (values && values.ratingDegree.length > 0 && values.ratingDegree.filter(i => i.ratingType && i.ratingType[0].code == "entity-punctuality-in-appointments").length > 0) {

                value[0].ratingTypes["entity-punctuality-in-appointments"].ratingTypeId = values.ratingDegree.filter(i => i.ratingType && i.ratingType[0].code == "entity-punctuality-in-appointments")[0].ratingTypeId
                value[0].ratingTypes["entity-punctuality-in-appointments"].degree = values.ratingDegree.filter(i => i.ratingType && i.ratingType[0].code == "entity-punctuality-in-appointments")[0].degree
                value[0].ratingTypes["entity-punctuality-in-appointments"].id = values.ratingDegree.filter(i => i.ratingType && i.ratingType[0].code == "entity-punctuality-in-appointments")[0].id
                value[0].ratingTypes["entity-punctuality-in-appointments"].operation = "edit"
            }
            if (values && values.ratingDegree.length > 0 && values.ratingDegree.filter(i => i.ratingType && i.ratingType[0].code == "entity-cleanliness-of-the-place").length > 0) {
                value[0].ratingTypes["entity-cleanliness-of-the-place"].ratingTypeId = values.ratingDegree.filter(i => i.ratingType && i.ratingType[0].code == "entity-cleanliness-of-the-place")[0].ratingTypeId
                value[0].ratingTypes["entity-cleanliness-of-the-place"].degree = values.ratingDegree.filter(i => i.ratingType && i.ratingType[0].code == "entity-cleanliness-of-the-place")[0].degree
                value[0].ratingTypes["entity-cleanliness-of-the-place"].id = values.ratingDegree.filter(i => i.ratingType && i.ratingType[0].code == "entity-cleanliness-of-the-place")[0].id
                value[0].ratingTypes["entity-cleanliness-of-the-place"].operation = "edit"

            }
            if (values && values.ratingDegree.length > 0 && values.ratingDegree.filter(i => i.ratingType && i.ratingType[0].code == "entity-service-quality").length > 0) {
                value[0].ratingTypes["entity-service-quality"].ratingTypeId = values.ratingDegree.filter(i => i.ratingType && i.ratingType[0].code == "entity-service-quality")[0].ratingTypeId
                value[0].ratingTypes["entity-service-quality"].degree = values.ratingDegree.filter(i => i.ratingType && i.ratingType[0].code == "entity-service-quality")[0].degree
                value[0].ratingTypes["entity-service-quality"].id = values.ratingDegree.filter(i => i.ratingType && i.ratingType[0].code == "entity-service-quality")[0].id
                value[0].ratingTypes["entity-service-quality"].operation = "edit"


            }
            if (values && values.comment) {

                value[0].comment = values.comment


            }
            if (values && values.waitingTime) {
                value[0].waitingTime = values.waitingTime


            }

            setInputList(value);



        }
    }, [props.open])
    return (
        <>

            <Dialog
                open={props.open}
                maxWidth={"xs"}
                fullWidth
                onClose={props.Close}
                PaperProps={{

                    // className: classes.paper
                }}
            >

                {printLogs("e==============", inputList[0])}

                <DialogContent style={{ position: "relative", width: "100%", direction: locale == "ar" ? "rtl" : "left" }}>

                    <Typography
                        style={{ textAlign: "center", fontWeight: "bold", direction: "rtl", padding: "0px 0px 20px 0", textAlign: "center" }}
                        variant="h4">
                        {t("Rating")}
                    </Typography>
                    <div className={style.RatingDialogdiv}>

                        {ratingTypes && ratingTypes.length > 0 ? ratingTypes.map(i => {

                            return (

                                <div className={style.ratingdiv}>

                                    <Typography

                                        variant="h5">
                                        {i.name}
                                    </Typography>
                                    <CustomeRating
                                        name={i.code}
                                        value={inputList[0].ratingTypes[i.code].degree} onChange={(event, newValue) => { setValue(newValue), handleChange(event) }} />




                                    {inputList[0].errorArray[i.code] && inputList[0].errorArray[i.code].value ? <FormHelperTxet

                                        error={inputList[0].errorArray[i.code].value}
                                    >
                                        {inputList[0].errorArray[i.code].message}
                                    </FormHelperTxet> : ""}
                                </div>
                            )

                        }) : ""}
                        {printLogs("ddddd", inputList[0]
                        )}
                        <div className={style.ratingdiv}>
                            <Typography

                                variant="h5">
                                {t("labelWaitingTime")}
                            </Typography>

                            <CustomeForm
                                className="textfield"
                                // label={t("lblUserName")}

                                // className="textfield"
                                onChange={(event) => { handleChange(event) }}
                                onKeyPress={(event) => {
                                    if (!/[0-9]/.test(event.key)) {
                                        event.preventDefault();
                                    }
                                }}
                                variant="outlined"
                                name="waitingTime"
                                value={inputList[0].waitingTime}
                            />

                            {inputList[0].errorArray.waitingTime && inputList[0].errorArray.waitingTime.value ? <FormHelperTxet
                                error={inputList[0].errorArray.waitingTime.value}
                            >
                                {inputList[0].errorArray.waitingTime.message}
                            </FormHelperTxet> : ""}
                        </div>

                        <CustomeForm
                            className="textfield"
                            // label={t("lblUserName")}
                            value={inputList[0].comment}
                            // className="textfield"

                            variant="outlined"
                            placeholder={t("comment")}
                            multiline
                            rows={4}
                            name="comment"
                            onChange={(event) => { handleChange(event) }}
                        />
                        {inputList[0].errorArray.comment && inputList[0].errorArray.comment.value ? <FormHelperTxet
                            error={inputList[0].errorArray.comment.value}
                        >
                            {inputList[0].errorArray.comment.message}
                        </FormHelperTxet> : ""}
                    </div>



                </DialogContent>
                <CustomeDialogActions
                    justifyContent="center"
                    style={{ justifyContent: "center", paddingBottom: "18px" }}
                >
                    <Customebtn
                        variant={"contained"}
                            color={"secondary"}
                        onClick={props.updateRating != null ? handleUpdate : handleSend}
                    >
                        {t("btnOk")}
                    </Customebtn>
                    <Customebtn
                        variant={"contained"}
                        // sx={{ backgroundColor: "#F52A59 !important" }}
                        onClick={props.btnCancel}
                        loading={props.loading}
                    >
                        {t("btnCancel")}

                    </Customebtn>

                    

                </CustomeDialogActions>
                {props.children}
            </Dialog>
        </>
    );
}
RatingDialog.propTypes = {
    confirm: PropTypes.func,
    reject: PropTypes.func,
    open: PropTypes.bool,
    onClose: PropTypes.func,
    text: PropTypes.string
}